import { render } from "./Slider.vue?vue&type=template&id=0d80497c&scoped=true&ts=true"
import script from "./Slider.vue?vue&type=script&lang=ts"
export * from "./Slider.vue?vue&type=script&lang=ts"

import "./Slider.vue?vue&type=style&index=0&id=0d80497c&lang=sass&scoped=true"

import exportComponent from "/home/ec2-user/environment/test_front/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d80497c"]])

export default __exports__